export default __webpack_public_path__ + "static/media/41.05c6514d.svg";